/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-list-dialog.vue?vue&type=template&id=1567f868&scoped=true&"
import script from "./uploader-list-dialog.vue?vue&type=script&lang=ts&"
export * from "./uploader-list-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./uploader-list-dialog.vue?vue&type=style&index=0&id=1567f868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567f868",
  null
  
)

export default component.exports